import { Component } from '@angular/core';
import { SelectTemplate } from 'src/app/@amiga-pyme/select/templates/select.template';
import { ROLE_ID } from 'src/app/auth/interfaces/role.interface';
import { IUser, IUserTable, USER_TTL_ES } from '../../user.interface';
import { UserService } from '../../user.service';

@Component({
  selector: 'pg-user-select',
  template: `
    <ami-select
      [settings]="table.settings"
      [data]="table.data"
      (selectedRowsEvent)="onReciveSelectedRows($event)"
    ></ami-select>
  `
})
export class UserSelectComponent extends SelectTemplate {
  constructor(private serviceBase: UserService) {
    super(USER_TTL_ES, serviceBase);
  }

  ngOnInit() {
    this.table.settings = {
      title: USER_TTL_ES,
      columns: [
        { header: 'Nombre', field: 'names' },
        { header: 'Apellido', field: 'surnames' },
        { header: 'Usuario', field: 'username' },
        { header: 'Cargo', field: 'role' }
      ]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IUser[]) => {
        this.parseToTable(data);
      });
  }

  parseToTable(dataService: IUser[]) {
    const dataTable: IUserTable[] = dataService.map((item) => {
      return {
        ...item,
        role: ROLE_ID[item.roleId]
      };
    });
    this.table.data = dataTable;
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
